/**
 * Backend errors are serialised as `{ error: { message } }` and land on
 * `ResponseError.body`, while `ResponseError.message` only holds the HTTP
 * status line. Reach into the body to get the explanation of what went wrong.
 */
export function serverErrorMessage(error: unknown): string | undefined {
  const message = (error as { body?: { error?: { message?: unknown } } })?.body
    ?.error?.message;

  return typeof message === 'string' && message ? message : undefined;
}

/**
 * Turns an error into a single readable sentence, dropping the chain of
 * `InputError: TypeError:` prefixes that the backend adds when it rethrows.
 */
export function errorHeadline(error: Error): string {
  return (serverErrorMessage(error) ?? error.message).replace(
    /^(\w*Error:\s+)+/,
    '',
  );
}
